import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import AuthPlugin from "./plugins/auth"
import VueCookie from 'vue-cookie';
import VueClipboard from 'vue-clipboard2'

Vue.use(AuthPlugin);
Vue.use(VueCookie);
Vue.use(VueClipboard);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router, 
  render: h => h(App),
}).$mount('#app')
 